module.exports = __webpack_public_path__ + "img/ZWF_DJ_SoulZ.54333c64.jpg";